// Resolves the .blur-up reveal. The markup uses the lazysizes convention
// (blur-up + lazyload -> lazyloaded), but the theme ships no lazysizes,
// so nothing ever added .lazyloaded and every image stayed at blur(8px).
//
// v2: images below the fold never fire 'load' on their own because the
// browser defers fetching (loading="lazy") and nothing observes them —
// so they sat at blur(8px) forever. An IntersectionObserver now forces
// the fetch as soon as an image nears the viewport, then reveals it.
(function () {
  function reveal(img) {
    img.classList.add('lazyloaded');
  }

  function watch(img) {
    if (img.dataset.blurUpWatched) return;
    img.dataset.blurUpWatched = '1';

    if (img.complete && img.naturalWidth > 0) {
      reveal(img);
      return;
    }

    img.addEventListener('load', function () {
      reveal(img);
    }, { once: true });

    // Force the browser to actually fetch lazy images when they approach
    // the viewport; without this, offscreen lazy images never load.
    if ('IntersectionObserver' in window) {
      observer.observe(img);
    } else if (img.loading === 'lazy') {
      img.loading = 'eager';
    }
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var img = entry.target;
        observer.unobserve(img);
        if (img.loading === 'lazy') img.loading = 'eager';
        // If the browser still hasn't fetched (e.g. data-src pattern),
        // nudge it; harmless when src is already set.
        if (img.dataset.src && !img.src) img.src = img.dataset.src;
        if (img.complete && img.naturalWidth > 0) reveal(img);
      });
    }, { rootMargin: '300px 0px' });
  }

  function init() {
    document.querySelectorAll('img.blur-up:not(.lazyloaded)').forEach(watch);
  }

  // Images injected later (facets, pagination, quick add) never pass through init.
  document.addEventListener('load', function (event) {
    var target = event.target;
    if (target.tagName === 'IMG' && target.classList.contains('blur-up')) reveal(target);
  }, true);

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
